import { render } from "./HeaderStore.vue?vue&type=template&id=4d38d19b&scoped=true"
import script from "./HeaderStore.vue?vue&type=script&lang=js"
export * from "./HeaderStore.vue?vue&type=script&lang=js"

import "@/assets/scss/_header-store.scss?vue&type=style&index=0&id=4d38d19b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d38d19b"]])

export default __exports__